import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import mountain from 'assets/images/mountain.png'
import { useGET_groupCoursesQuery } from 'redux/api/groupCoursesApi'
import { PRIMARY_BLUE } from 'utils/customizedTheme'

const SectionMyTarget: FC = () => {
  const { t } = useTranslation()

  const [subject, setSubject] = useState(null)

  const { data } = useGET_groupCoursesQuery({
    page: 1,
  })

  useEffect(() => {
    if (data?.results.length > 0) {
      setSubject(data?.results[0].subject?.id ?? null)
    }
  }, [data])

  return (
     <div>
        <div className="workspace-tabs">
            {data?.results?.map((s) => <div key={s.id} className={`workspace-tab ${subject==s.id && 'selected'}`}
                onClick={() => {setSubject(s.id)}}
            >
                {s.subject?.title}
            </div>)}    
        </div>
        <div className="workspace-tabs-box" style={{ border: `1px solid ${PRIMARY_BLUE}`}}>
            {subject && <div className='my-target'>

                <div className='my-target-pic'>
                    <img src={mountain} />
                </div>
                <div>
                    <div className='my-target-text'>{t('dashboard.my-target-is')} <span>D</span></div>
                    <div className='my-target-text'>{t('dashboard.i-have-achieved')} <span>{(50 + subject)}%</span> {t('dashboard.of-target')}</div>
                </div>
                
            </div>}
        </div>
     </div>
  )
}

export default SectionMyTarget
